import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { PaymentOptionType } from '@debbie/common/dist/collectors';
import helpers from '@debbie/common/dist/economy/helpers';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors';
import { selectMe } from '@debbie/cortex/dist/me/selectors';
import { LineThrough, Checkbox, Button, MoneyInput } from '../..';
import card_dan from '../../../assets/images/card_dan.png';
import card_master from '../../../assets/images/card_master.png';
import card_visa from '../../../assets/images/card_visa.png';
import mobilepay from '../../../assets/images/mobilepay.png';
import payment_bs from '../../../assets/images/payment_bs.png';
import payment_ls from '../../../assets/images/payment_ls.png';
import { APIBASE } from '../../../config';
const Farpay = (props) => {
    const { paymentOption, collector, case: singleCase, caseVouchers } = props;
    const lang = useSelector((s) => s.lang);
    const me = useSelector(selectMe);
    const authToken = useSelector(selectAuthToken);
    const [businessTermsAccepted, setBusinessTermsAccepted] = useState(false);
    const [partialPayment, setPartialPayment] = useState(false);
    const [amount, setAmount] = useState(caseVouchers
        ? Math.round(-helpers.overview.balance(caseVouchers) / 2)
        : null);
    if (!collector.businessTerms || props.isPaymentPlan)
        return null;
    return (React.createElement("div", null,
        props.paymentOptionsCount > 1 && (React.createElement(LineThrough, null,
            React.createElement("span", null, lang.debtorWebHome.or))),
        React.createElement(Checkbox, { value: businessTermsAccepted, onChange: (e) => setBusinessTermsAccepted(e.target.checked), placeholder: React.createElement("span", null,
                lang.debtorWebHome.iApprove,
                ' ',
                React.createElement("a", { target: "_blank", href: collector.businessTerms, rel: "noreferrer" }, lang.debtorWebHome.theBusinessTerms)) }),
        !props.avoidPartialPayments && (React.createElement(FullOrPartialPayment, null,
            React.createElement(Button, { onClick: () => setPartialPayment(false), theme: partialPayment ? 'secondary' : undefined }, lang.debtorWebHome.fullPayment),
            React.createElement(Button, { onClick: () => setPartialPayment(true), theme: partialPayment ? undefined : 'secondary' }, lang.debtorWebHome.partialPayment))),
        partialPayment && caseVouchers && (React.createElement(PartialPayment, null,
            React.createElement(MoneyInput, { value: amount, allowNull: true, min: 0, max: -helpers.overview.balance(caseVouchers), placeholder: lang.paymentPlans.amount, onChange: setAmount }))),
        me && authToken && (React.createElement(Button, { block: true, href: `${APIBASE}/payments/payment-portal/${singleCase.caseId}/${singleCase.collectorId}?acceptURL=${window.location.href + '/paid'}&customerName=${encodeURIComponent(me.firstName + ' ' + me.lastName)}&authToken=${authToken}${partialPayment ? '&amount=' + amount : ''}`, disabled: (caseVouchers && -helpers.overview.balance(caseVouchers) < 100) ||
                !businessTermsAccepted ||
                !amount ||
                amount < 1000 }, lang.debtorWebHome.payWithCardButton)),
        paymentOption &&
            paymentOption.isActive &&
            paymentOption.type === PaymentOptionType.FARPAY && (React.createElement("div", { className: "providers" },
            paymentOption.details.visa && React.createElement(Card, { src: card_visa }),
            paymentOption.details.mastercard && React.createElement(Card, { src: card_master }),
            paymentOption.details.dankort && React.createElement(Card, { src: card_dan }),
            paymentOption.details.mobilepay && React.createElement(Card, { src: mobilepay }),
            paymentOption.details.betalingsservice && (React.createElement(Card, { src: payment_bs })),
            paymentOption.details.leverandorservice && (React.createElement(Card, { src: payment_ls }))))));
};
export default Farpay;
const Card = styled.img `
  margin: 0 6px;
`;
const FullOrPartialPayment = styled.div `
  margin-bottom: 10px;
  display: inline-flex;
  width: 100%;
  justify-content: center;
`;
const PartialPayment = styled.div `
  margin-bottom: 10px;
  width: 100%;
`;
//# sourceMappingURL=Farpay.js.map